import actionTypes from './optOutConfirmation.actionTypes';

const initialState = {
  visible: false,
  formInstance: {}
};

export default function optOutConfirmationModalReducer (state = initialState, action) {
  switch (action.type) {
    case actionTypes.SHOW_OPT_OUT_MODAL: {
      return {
        ...state,
        visible: true,
        formInstance: action.data
      };
    }
    case actionTypes.DISMISS_OPT_OUT_MODAL: {
      return {
        ...initialState
      };
    }
    case actionTypes.SET_OPT_OUT_REASON: {
      let reason = action.data;
      return {
        ...state,
        formInstance: {
          ...state.formInstance,
          optOutReason: reason
        }
      };
    }
    default: {
      return state;
    }
  }
}
